import axios from 'axios'
import getEnv from '../lib/get-env.js'

export const addAccountIdentityAssignment = async ({
  newBearerToken,
  bearerToken,
  accountUserId,
}) => {
  await axios.post(
    `${getEnv(
      'REACT_APP_ACCOUNT_URL'
    )}/v1/users/${accountUserId}/actions/add-identity-assignment`,
    {
      token: newBearerToken,
      authVendorId: getEnv('REACT_APP_ACCOUNT_AUTH_VENDOR_ID'),
    },
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  )
}
